import { render, staticRenderFns } from "./riesgosNoModificable.vue?vue&type=template&id=e4c1e038&scoped=true&"
import script from "./riesgosNoModificable.vue?vue&type=script&lang=js&"
export * from "./riesgosNoModificable.vue?vue&type=script&lang=js&"
import style0 from "./riesgosNoModificable.vue?vue&type=style&index=0&id=e4c1e038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c1e038",
  null
  
)

export default component.exports